import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function InventoryCategory() {
    
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        status: 1
    });
    useEffect(() => {
        getCategories();
    }, []);
    const getCategories = () => {
        setLoading(true);
        axios.get(baseUrl + "inventory-category/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            name: "",
            description: "",
            status: 1
        });
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            name: row.name,
            description: row.description,
            status: row.status
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Category?",
            icon: "warning",
            showCancelButton: true
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`delete-inventory-category/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted",
                                "",
                                "success");
                            getCategories();
                        });
                }
            });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("name", formData.name);
            data.append("description", formData.description);
            data.append("status", formData.status);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);
            if (editId === null) {
                await axios.post(baseUrl + "inventory-category/",
                    data);
            } else {
                await axios.put(baseUrl + `update-inventory-category/${editId}/`,
                    data);
            }
            Swal.fire("Success",
                editId === null
                    ? "Category Saved"
                    : "Category Updated",
                "success");
            clearForm();
            getCategories();
        } catch (error) {
            Swal.fire("Error",
                "Unable to Save Category",
                "error");
        }
        setLoading(false);
    };
    const columns = [
        {
            field: "name",
            headerName: "Category Name",
            width: 220
        },
        {
            field: "description",
            headerName: "Description",
            width: 350
        },
        {
            field: "status",
            headerName: "Status",
            width: 120,
            renderCell: (params) => (
                params.row.status === 1
                    ? "Active"
                    : "Inactive"
            )
        },
        {
            field: "action",
            headerName: "Action",
            width: 180,
            renderCell: (params) => (
                <>


                    <button


                        className="btn btn-success btn-sm me-2"


                        onClick={() => editData(params.row)}


                    >


                        Edit


                    </button>


                    <button


                        className="btn btn-danger btn-sm"


                        onClick={() => deleteData(params.row.id)}


                    >


                        Delete


                    </button>


                </>
            )
        }
    ];
    return (
        <div className="container-fluid mt-3">


            <div className="card shadow">


                <div className="card-header bg-success text-white">


                    <h5 className="mb-0">

                        Inventory Category

                    </h5>


                </div>


                <div className="card-body">


                    <form onSubmit={saveData}>


                        <div className="row">


                            <div className="col-md-4 mb-3">


                                <label>

                                    Category Name

                                </label>


                                <input


                                    type="text"


                                    className="form-control"


                                    name="name"


                                    value={formData.name}


                                    onChange={handleChange}


                                    required


                                />


                            </div>


                            <div className="col-md-6 mb-3">


                                <label>

                                    Description

                                </label>


                                <textarea


                                    className="form-control"


                                    rows="2"


                                    name="description"


                                    value={formData.description}


                                    onChange={handleChange}


                                />


                            </div>

                            <div className="col-md-2 mb-3">


                                <label>

                                    Status

                                </label>


                                <select


                                    className="form-control"


                                    name="status"


                                    value={formData.status}


                                    onChange={handleChange}


                                >


                                    <option value="1">

                                        Active

                                    </option>


                                    <option value="0">

                                        Inactive

                                    </option>


                                </select>


                            </div>


                            <div className="col-md-12 mt-3">


                                <button


                                    type="submit"


                                    className="btn btn-success me-2"


                                    disabled={loading}


                                >


                                    {
                                        editId === null
                                            ? "Save Category"
                                            : "Update Category"
                                    }


                                </button>


                                <button


                                    type="button"


                                    className="btn btn-secondary"


                                    onClick={clearForm}


                                >


                                    Clear


                                </button>


                            </div>


                        </div>


                    </form>


                </div>


            </div>

            <div className="card shadow mt-3">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Inventory Category List

                    </h5>


                </div>


                <div className="card-body">


                    <div

                        style={{
                            height: 600,
                            width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={rows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            pageSizeOptions={[
                                10,
                                25,
                                50,
                                100
                            ]}


                            


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>
    );
}
export default InventoryCategory;